"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _tinycolor = _interopRequireDefault(require("tinycolor2"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _theme = require("../utils/theme");
var _functions = require("../utils/functions");
var _helpers = require("@qwkin/helpers");
var _Modal = require("./Modal.styles");
var _IconButton = require("../IconButton");
var _Text = require("../Text");
var _excluded = ["theme", "elevation", "title", "onOpen", "onClose", "hasCloseButton", "isOpen", "shouldCloseOnOverlayClick", "children"];
if (document.getElementById('root')) {
  _reactModal["default"].setAppElement('#root');
}
var DefaultModal = function DefaultModal(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$elevation = _ref.elevation,
    elevation = _ref$elevation === void 0 ? 'small' : _ref$elevation,
    title = _ref.title,
    _ref$onOpen = _ref.onOpen,
    onOpen = _ref$onOpen === void 0 ? _helpers.identity : _ref$onOpen,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? _helpers.identity : _ref$onClose,
    _ref$hasCloseButton = _ref.hasCloseButton,
    hasCloseButton = _ref$hasCloseButton === void 0 ? true : _ref$hasCloseButton,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
    shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_reactModal["default"], (0, _extends2["default"])({
    elevation: elevation,
    isOpen: isOpen,
    onAfterOpen: onOpen,
    onRequestClose: onClose,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    style: {
      content: {
        position: 'relative',
        top: 'auto',
        left: 'auto',
        right: 'auto',
        bottom: 'auto',
        border: 'none',
        borderRadius: '8px',
        zIndex: '0',
        padding: '16px',
        overflow: 'visible',
        transition: 'all 150ms ease',
        boxShadow: (0, _functions.getBoxShadowByElevation)({
          elevation: elevation,
          theme: theme
        })
      },
      overlay: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '100',
        backdropFilter: 'blur(2px)',
        background: (0, _tinycolor["default"])('#000000').setAlpha(0.3).toRgbString()
      }
    }
  }, props), /*#__PURE__*/_react["default"].createElement(_Modal.ModalHeader, null, title ? /*#__PURE__*/_react["default"].createElement(_Text.Text, {
    weight: "bold",
    type: "subtitle"
  }, title) : /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%'
    }
  }), hasCloseButton && /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    dense: true,
    onClick: onClose,
    icon: "close",
    color: "red",
    size: "20",
    format: "round"
  })), children));
};
var _default = exports["default"] = DefaultModal;